module.exports = "<app-sprout-home></app-sprout-home>"